import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoadingComponent } from './loading/loading.component';
import { LoginComponent } from './login/login.component';
import { AuthComponent } from './auth/auth.component';
import { SmsComponent } from './sms/sms.component';
import { PaneladminComponent } from './paneladmin/paneladmin.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { IMaskModule } from 'angular-imask';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../environments/environment';
import { AngularFireDatabaseModule } from '@angular/fire/database';


const routes:Routes = [
  { path: '', redirectTo: 'Loading', pathMatch: 'full' },
  { path: 'Login', component: LoginComponent },
  { path: 'Loading', component: LoadingComponent },
  { path: 'otp', component: SmsComponent },
  { path: 'auth', component: AuthComponent },
  { path: 'authvisitors', component: PaneladminComponent },
  { path: '**', component: LoadingComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    LoadingComponent,
    LoginComponent,
    AuthComponent,
    SmsComponent,
    PaneladminComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    IMaskModule,
    BrowserAnimationsModule,
    AngularFireDatabaseModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule.forRoot(routes),
    RouterModule,
    AngularFireModule.initializeApp(environment.firebase)
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
